import { CurrencyInput, CurrencyInputProps } from '@round/whitelabel-ui';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import styles from './AllocationInput.module.css';
import cn from 'classnames';

type Props = {
    currencyId?: number;
} & Pick<
    CurrencyInputProps,
    'onValueChange' | 'value' | 'max' | 'placeholder' | 'onKeyDown' | 'onBlur' | 'disabled' | 'className' | 'readOnly'
>;

const AllocationInput = ({ currencyId, className, ...props }: Props) => {
    const { getCurrencyById } = useCurrencies();
    const prefix = getCurrencyById(currencyId)?.symbol || '';

    return (
        <CurrencyInput
            groupSeparator=","
            allowDecimals
            decimalSeparator="."
            decimalsLimit={2}
            decimalScale={2}
            prefix={prefix}
            className={cn(styles.input, className)}
            min={0}
            {...props}
        />
    );
};

export default AllocationInput;
